import React, { ReactNode, useState } from "react"
import { useSelector } from "react-redux"
import { Button } from "react-bootstrap"
import IntlProps from "../../state/helpers/IntlProps"
import { injectIntl } from "react-intl"
import { CREATE_PO_BUTTON_MESSAGES } from "../../utils/order"
import { CreatePOModal } from "../modals"
import { CreatePOButtonProps } from "../../common/types/order"
import Icon from "../../common/icon/icon.component"
import { PricingTableSelector } from "../../state/pricing/selectors"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

export const CreatePOButton = injectIntl((props: CreatePOButtonProps & IntlProps) => {
    const [modal, setModal] = useState<ReactNode | null>(null)
    const items = useSelector(PricingTableSelector.getItemsTrackingInventoryWithRequestedMeasure)

    if (!AppContext.isInventoryEnabled()) {
        return null
    }

    const fullyReceivedRows = items
        .filter(item => item.attributes.inventoryReceivedMeasure === item.attributes.inventoryRequestedMeasure)

    if (fullyReceivedRows.length === items.length) {
        return null
    }

    const onOpenModal = () => {
        setModal(
            <CreatePOModal onCloseCallback={() => setModal(null)} {...props} items={items}/>
        )
    }

    return (
        <>
            {modal}
            <Button variant={"outline-secondary"} onClick={onOpenModal} className={"mb-2 mr-2"}>
                <Icon value={"truck-moving"} className={"px-1"}/>
                {props.intl.formatMessage(CREATE_PO_BUTTON_MESSAGES.buttonLabel)}
            </Button>
        </>
    )
})


// WEBPACK FOOTER //
// ./src/order/components/CreatePOButton.tsx